import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid'
import { TypographyVariant } from '@material-ui/core/styles';
import { HelpProps } from '../common/props/viewProps';
import HelpButton from '../help/HelpButton';

interface ViewHeaderBarProps extends HelpProps {
    /**
     * View header title.
     */
    title: string;
    /**
     * View header typography variant.
     */
    titleVariant?: TypographyVariant;
}

/*
    Renders view header bar with title text and custom components on the right side.
*/
const ViewHeaderBar: React.SFC<ViewHeaderBarProps> = (props) => {

    const { title } = props;
    const variant = props.titleVariant || "h3";

    const showHelp = props.showHelp;

    return <div>
        <Grid container justify="space-between" alignItems="center">
            <Grid item>
                <Grid container spacing={8} direction="row" alignItems="center">
                    <Grid item>
                        <Typography variant={variant}><b>{title}</b></Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-end" alignItems="center" spacing={2}>
                    {React.Children.map(props.children, (item) => <Grid item>{item}</Grid>)}
                    {showHelp ?
                        <Grid item>
                            <HelpButton anchor={props.helpAnchor} />
                        </Grid>
                        : null
                    }
                </Grid>
            </Grid>
        </Grid>
        <br />
        <br />
    </div>
}

export default ViewHeaderBar;


// WEBPACK FOOTER //
// ./src/components/ViewHeaderBar.tsx